<template>
  <section id="servicios">
    <div class="servicios-container">
      <div class="header-section text-center">
        <h2 class="section-title">Nuestros Servicios</h2>
        <p class="section-subtitle">Ofrecemos soluciones integrales de alta calidad para satisfacer las necesidades de
          cada cliente.</p>
      </div>

      <div class="servicios-grid">
        <div class="service-card shadow-sm">
          <div class="icon-wrapper">
            <i class='bx bx-server'></i>
          </div>
          <h3>Hosting y Correo</h3>
          <p>Alojamiento de alta performance, velocidad y correos corporativos seguros para tu negocio.</p>
        </div>

        <div class="service-card shadow-sm">
          <div class="icon-wrapper">
            <i class='bx bx-support'></i>
          </div>
          <h3>Asistencia Técnica</h3>
          <p>Soporte continuo y asesoramiento técnico profesional para asegurar el éxito de tus operaciones.</p>
        </div>

        <div class="service-card shadow-sm">
          <div class="icon-wrapper">
            <i class='bx bx-code-alt'></i>
          </div>
          <h3>Desarrollo a Medida</h3>
          <p>Creamos sistemas y diseños exclusivos, escalables y orientados a tus objetivos comerciales.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
#servicios {
  width: 100%;
  padding: 6rem 2rem;
  background: white;
}

.servicios-container {
  max-width: 1200px;
  margin: 0 auto;
}

.header-section {
  margin-bottom: 5rem;
}

.section-title {
  font-size: 2.5rem;
  color: var(--text-main);
  margin-bottom: 1rem !important;
  width: 100%;
}

.section-subtitle {
  font-size: 1.1rem;
  color: var(--text-muted);
  max-width: 600px;
  margin: 0 auto !important;
}

.servicios-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2.5rem;
}

.service-card {
  background: white;
  border-radius: 20px;
  padding: 2.5rem 2rem;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all var(--duration);
  position: relative;
  overflow: hidden;

  h3 {
    width: 100%;
  }

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08) !important;
    border-color: rgba(79, 70, 229, 0.2);

    .icon-wrapper {
      background: var(--primary);
      color: white;
      transform: scale(1.1);
    }
  }
}

.icon-wrapper {
  width: 70px;
  height: 70px;
  margin: 0 auto 1.5rem auto;
  background: rgba(79, 70, 229, 0.1);
  color: var(--primary);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  transition: all var(--duration);
}

.service-card h3 {
  font-size: 1.25rem;
  margin-bottom: 1rem !important;
  color: var(--text-main);
}

.service-card p {
  color: var(--text-muted);
  line-height: 1.6;
  font-size: 0.95rem;
}

@media screen and (max-width: 768px) {
  #servicios {
    padding: 4rem 1rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .servicios-grid {
    gap: 1.5rem;
  }
}
</style>
<script setup lang="ts">
</script>